import { Row } from 'components/UI/Grid'
import styled from 'styled-components'

const DetailTableRow = styled(Row)`
  padding: 16px;
  border-bottom: ${props => props.theme.border};
`

export default DetailTableRow
